import _extends from'@babel/runtime/helpers/extends';import _objectWithoutProperties from'@babel/runtime/helpers/objectWithoutProperties';import React,{useCallback}from'react';import PropTypes from'prop-types';import {useIntl}from'react-intl';import styled from'styled-components';import {validOTPCode}from'../../utils/validation.js';import FormTextInput from'../FormTextInput/FormTextInput.js';var OTP_LENGTH = 6;
var Wrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "OneTimeCode__Wrapper",
  componentId: "sc-1uqtv5n-0"
})(["display:block;"]);
var OneTimeCode = function OneTimeCode(_ref) {
  var id = _ref.id,
    onChange = _ref.onChange,
    labelId = _ref.labelId,
    value = _ref.value,
    rest = _objectWithoutProperties(_ref, ["id", "onChange", "labelId", "value"]);
  var intl = useIntl();
  var label = intl.formatMessage({
    id: labelId
  });
  var LENGTH_MULTIPLIER = 2;
  var handleChange = useCallback(function (code, event) {
    onChange(code === null || code === void 0 ? void 0 : code.replace(/[^0-9]/g, ''), event);
  }, [onChange]);
  var focusFirstNonMaskedCharacter = useCallback(function (event) {
    var inputElement = event.target;
    if (!inputElement) {
      return;
    }

    // Since there are spaces between the numbers, we need to double the length to get the actual position.
    var firstMasked = value.length * LENGTH_MULTIPLIER;
    if (inputElement.selectionStart < firstMasked) {
      return;
    }
    inputElement.focus();
    inputElement.setSelectionRange(firstMasked, firstMasked);
  }, [value.length]);
  var handlePaste = useCallback(function (event) {
    // Special handling for when a user pastes a full 6-digit code.
    // Instead of pasting from the current cursor position and chopping off the rest
    // just replace the input with the entire 6-digit code.
    // This should help improve user experience when pasting a complete code, especially on mobile.
    try {
      var inputElement = event.target;
      var clipboardData = event.clipboardData || window.clipboardData;
      var pasteValue = clipboardData.getData('text');
      var formattedPasteValue = pasteValue.replace(/[^0-9]/g, '');
      if (formattedPasteValue.length === OTP_LENGTH) {
        handleChange(formattedPasteValue, event);
        setTimeout(function () {
          return inputElement.setSelectionRange(OTP_LENGTH * LENGTH_MULTIPLIER, OTP_LENGTH * LENGTH_MULTIPLIER);
        }, 0);
        event.preventDefault();
      } else {
        // Do nothing, let the browser default behaviour happen
      }
    } catch (err) {
      // If the browser doesn't support clipboard or selection range
      // do nothing and just let the browser default behaviour happen
    }
  }, [handleChange]);
  return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(FormTextInput, _extends({
    id: id,
    label: label,
    value: value,
    onChange: handleChange,
    onClick: focusFirstNonMaskedCharacter,
    onKeyDown: focusFirstNonMaskedCharacter,
    onKeyUp: focusFirstNonMaskedCharacter,
    onPaste: handlePaste,
    customStyle: {
      rootStyle: {
        marginBottom: '1.25rem'
      }
    },
    validations: validOTPCode,
    callouts: true,
    inputmode: "numeric",
    autocomplete: "one-time-code",
    minLength: OTP_LENGTH,
    maxLength: OTP_LENGTH,
    pattern: "\\d{6}"
  }, rest)));
};
process.env.NODE_ENV !== "production" ? OneTimeCode.propTypes = {
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  labelId: PropTypes.string,
  value: PropTypes.string
} : void 0;
OneTimeCode.defaultProps = {
  labelId: 'shared.code',
  value: ''
};
var OneTimeCode$1 = OneTimeCode;export{OneTimeCode$1 as default};